import React from "react";
import NavbarLayout from "~/src/components/navbar/NavbarLayout";
import CollectionBySlugPage from "~/src/components/collection/pages/CollectionBySlugPage";

export default function CollectionBySlug() {
  return (
    <NavbarLayout
      navbarProps={{
        mb: 0,
      }}
    >
      <CollectionBySlugPage />
    </NavbarLayout>
  );
}
